import { Payment } from 'src/contexto/hooks/usePaymentMethod'

export const arePixAndBilletAvailable = (payment: Payment): boolean =>
  Boolean(payment.pix && payment.billet)

export const arePixOrBilletAvailable = (payment: Payment): boolean =>
  Boolean(payment.pix || payment.billet)

export const isOnlyBilletInCashAvailable = (payment: Payment): boolean =>
  Boolean(!payment.pix && payment.billet)

export const isOnlyPixInCashAvailable = (payment: Payment): boolean =>
  Boolean(payment.pix && !payment.billet)

export const isCreditCardAvailable = (payment: Payment): boolean =>
  Boolean(payment.creditCard)

export const getInCashAvailablePaymentMethods = (payment: Payment): string => {
  if (arePixAndBilletAvailable(payment)) return 'Pix ou Boleto'
  if (!arePixOrBilletAvailable(payment)) return ''
  return isOnlyPixInCashAvailable(payment) ? 'Pix' : 'Boleto'
}

export const hoursToCountAsNotCurrentCancelling = (): number => 72
